<ng-container [ngSwitch]="remoteConfigStore.typeOfBookingPackage$ | async">
  <app-commercial-subscription-summary
    *ngSwitchCase="BookingSubscriptionPackageOptions.Commercial"
  ></app-commercial-subscription-summary>
  <app-flat-subscription-summary
    *ngSwitchCase="BookingSubscriptionPackageOptions.FlatRate"
  ></app-flat-subscription-summary>
  <app-voucher-subscription-summary
    *ngSwitchCase="BookingSubscriptionPackageOptions.UserUsaCanada"
  ></app-voucher-subscription-summary>
  <app-subscription-summary *ngSwitchDefault></app-subscription-summary>
</ng-container>
